<template>
    <v-dialog v-model="showModal" persistent :width="$vuetify.breakpoint.thresholds.sm">
        <template #activator="{ on, attrs }">
            <v-tooltip bottom>
                <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                    <v-btn icon v-on="{ ...on, ...tooltipOn }" v-bind="{ ...attrs, ...tooltipAttrs }" :disabled="!isSelected" color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('Lernziel löschen') }}</span>
            </v-tooltip>
        </template>
        <DeleteConfirm
            :hasToolbar="true"
            :toolbarTitle="$t('Lernziel löschen')"
            :deleteMessage="$t('Sind Sie sicher, dass Sie dieses Lernziel löschen möchten?')"
            :checkboxDeleteMessage="$t('Diese Aktion kann nicht rückgängig gemacht werden.')"
            @deleteItem="deleteLearningGoals"
            @closeEmit="close"
        />
    </v-dialog>
</template>
<script>
import CourseMixin from './Mixins/CourseMixin';
import DeleteConfirm from '../../Generic/DeleteConfirm';

export default {
    name: 'delete-learning-goals',
    mixins: [CourseMixin],
    data: () => ({
        showModal: false
    }),
    components: {
        DeleteConfirm
    },
    computed: {
        isSelected() {
            return Object.keys(this.getSelectedLearningGoal).length > 0;
        }
    },
    methods: {
        close() {
            this.showModal = false;
        },
        deleteLearningGoals() {
            this.DELETE_LEARNING_GOAL(this.getSelectedLearningGoal)
                .then(() =>
                    this.UPDATE_TOPIC_LEARNING_GOALS({
                        course: this.getSelectedAdminCourse,
                        topic: this.getSelectedTopic,
                        learningGoals: [...this.getTopicLearningGoals]
                    })
                )
                .then(() => this.close());
        }
    }
};
</script>
